// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js","989":"component---src-templates-blog-post-js"}[chunkId] + "-" + {"678":"04a35f646e9d82703e07","883":"75ee4ca92fb7cb56f542","989":"d12f493cb79d39577375"}[chunkId] + ".js";
};